// List.tsx
import { ClusterInterface, MetricsSummary } from '../../../../../common/types/interfaces'
import { Item } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: ClusterInterface) => void
  showDetails: (el: ClusterInterface) => void
  showStats: (el: ClusterInterface) => void
  list: ClusterInterface[] | []
  switchCluster: (el: ClusterInterface) => void
  loading: boolean
  openPayment: (el: ClusterInterface) => void
  openExtend: (el: ClusterInterface) => void
  metricsMap: Record<string, MetricsSummary>
}

export const List = ({
  startEdit,
  list,
  showDetails,
  switchCluster,
  loading,
  openPayment,
  metricsMap,
  showStats,
  openExtend,
}: Props) => {
  if (loading) return <div className={classes.container}></div>

  return (
    <div className={classes.container}>
      {!list?.length ? (
        <div className={classes.Message}>Нет кластеров</div>
      ) : (
        list.map((el) => (
          <Item
            switchCluster={switchCluster}
            showDetails={showDetails}
            el={el}
            startEdit={startEdit}
            key={el.id}
            openPayment={openPayment}
            metrics={el.domain ? metricsMap[el.domain] : null}
            showStats={showStats}
            openExtend={openExtend}
          />
        ))
      )}
    </div>
  )
}
